<template>
  <div class="layout-base-full">
    <main class="layout-base-full__content">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
onMounted(() => {
  document.documentElement.style.overflow = 'hidden'
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.documentElement.style.overflow = ''
  document.body.style.overflow = ''
})
</script>

<style lang="scss" scoped>
.layout-base-full {
  background-color: var(--color-surface-placeholder);
  display: flex;
  flex-direction: column;
  height: 100dvh;

  &__content {
    @include container;

    flex: 1;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-top: rem(32px);
    padding-bottom: rem(32px);

    @include bp-media('xs', 'sm') {
      padding-top: rem(26px);
      padding-bottom: rem(26px);
    }

    @include bp-media('xs') {
      padding-top: rem(16px);
      padding-bottom: rem(16px);
    }
  }
}
</style>
